<template>
    <div class="notification-container">
        <div 
            v-for="notification in notifications" 
            :key="notification.id"
            :class="['notification', 'notification-' + notification.type]"
        >
            {{ notification.text }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationContainer',
    props: {
        notifications: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style scoped>
.notification-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 999999;
    pointer-events: none;
}

.notification {
    background: #28a745;
    color: white;
    padding: 12px 16px;
    border-radius: 4px;
    margin-bottom: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    animation: slideIn 0.3s ease-out;
    pointer-events: auto;
    min-width: 200px;
    font-size: 14px;
}

.notification-success {
    background: #28a745;
}

.notification-error {
    background: #dc3545;
}

.notification-warning {
    background: #ffc107;
    color: #212529;
}

.notification-info {
    background: #17a2b8;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/Assets/components/Common/NotificationContainer.vue